// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Lui_ai__Composer from "lui.ai/composer.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_attachment_input from "./web_attachment_input.js";
import * as Mapre_web__Web_attachments_controller from "./web_attachments_controller.js";
import * as Mapre_web__Web_attachments_model from "./web_attachments_model.js";
import * as Mapre_web__Web_attachments_view from "./web_attachments_view.js";
import * as Mapre_web__Web_chat_adapter from "./web_chat_adapter.js";
import * as Mapre_web__Web_message_model from "./web_message_model.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_recovery_model from "./web_recovery_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__Option from "melange/option.js";

function allowed(m) {
  if (Mapre_web__Web_model.can_create(m)) {
    return !Mapre_web__Web_model.locked(m);
  } else {
    return false;
  }
}

function ready(m) {
  if (allowed(m) && Mapre_web__Web_message_model.ready(m.messages, m.subscriptions)) {
    if (Mapre_web__Web_message_model.resume(m.messages) === undefined) {
      return true;
    } else {
      return !m.subscriptions_loading;
    }
  } else {
    return false;
  }
}

function status(m) {
  if (m.messages.continuing_from !== undefined) {
    return "Restoring session...";
  }
  const recovery = Stdlib__Option.bind(m.messages.control, (function (c) {
    return c.recovery;
  }));
  if (recovery !== undefined) {
    return Mapre_web__Web_recovery_model.description(recovery);
  } else if (allowed(m)) {
    if (Mapre_web__Web_message_model.resume(m.messages) !== undefined) {
      if (m.subscriptions_loading) {
        return "Loading accounts...";
      } else if (Mapre_web__Web_message_model.continuation_ready(m.messages, m.subscriptions)) {
        return "";
      } else {
        return "Review your account and budget in Session settings.";
      }
    }
    const match = Stdlib__Option.bind(m.messages.control, (function (c) {
      return c.reason;
    }));
    if (match === undefined) {
      return "";
    }
    switch (match) {
      case "run_not_active" :
        return "This run is not accepting new messages.";
      case "runtime_initializing" :
        return "The runtime is preparing this conversation.";
      case "session_resume_required" :
        const match$1 = Stdlib__Option.bind(m.messages.control, (function (c) {
          return c.resume_reason;
        }));
        if (match$1 === undefined) {
          return "Resume this session before sending another message.";
        }
        switch (match$1) {
          case "resume_cleanup_pending" :
            return "Stopping this session before it can continue.";
          case "resume_retention_expired" :
            return "The retained environment has expired.";
          case "resume_source_unavailable" :
            return "This session needs recovery before it can continue.";
          default:
            return "Resume this session before sending another message.";
        }
      default:
        return "";
    }
  } else {
    return "Only members with execution permission can send messages.";
  }
}

function retry_button(send, source) {
  const partial_arg = {
    TAG: /* Messages */ 43,
    _0: /* Retry */ 2
  };
  const partial_arg$1 = (function (param) {
    return Lui_elements.press(send, partial_arg, param);
  });
  const partial_arg$2 = "sm";
  const partial_arg$3 = "outline";
  const partial_arg$4 = "Retry same message";
  const partial_arg$5 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$6 = Signal.map((function (m) {
    if (allowed(m) && !m.messages.denied) {
      return Stdlib__Option.fold(false, (function (a) {
        return a.phase === /* Uncertain */ 1;
      }), m.messages.attempt);
    } else {
      return false;
    }
  }), source);
  return function (param, param$1) {
    return Lui_elements.if_(partial_arg$6, partial_arg$5, param, param$1);
  };
}

function attachments_visible(m) {
  const state = m.messages.attachments;
  if (Caml_obj.caml_notequal(state.items, /* [] */ 0)) {
    return true;
  } else {
    return state.message !== "";
  }
}

function attach_button(source, on_attach) {
  return function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___001_) {
      const partial_arg = on_attach;
      const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (m) {
        return !Mapre_web__Web_attachments_controller.allowed(/* Conversation */ 1, m);
      }), source)));
      const partial_arg$2 = "Attach files";
      const partial_arg$3 = {
        NAME: "app",
        VAL: "plus"
      };
      const partial_arg$4 = "icon";
      const partial_arg$5 = "ghost";
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, partial_arg$4, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
}

function composer_capsule(send, source, on_attach) {
  const partial_arg = Signal.map(allowed, source);
  const partial_arg$1 = Mapre_web__Web_attachments_view.strip(/* Conversation */ 1, source, send);
  const partial_arg$2 = 0;
  const partial_arg$3 = 6;
  const partial_arg$4 = (function (param) {
    Curry._1(send, {
      TAG: /* Messages */ 43,
      _0: /* Stop */ 1
    });
  });
  const partial_arg$5 = "Stop generating";
  const partial_arg$6 = {
    NAME: "app",
    VAL: "stop"
  };
  const partial_arg$7 = "icon";
  const partial_arg$8 = "secondary";
  const partial_arg$9 = function (param, param$1) {
    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, partial_arg$7, partial_arg$6, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$10 = Signal.map(Mapre_web__Web_chat_adapter.generating, source);
  return Lui_ai__Composer.composer(undefined, "Message", "Message Mapre", true, undefined, "Send message", "Stop generating", undefined, Signal.map((function (m) {
    return m.messages.draft;
  }), source), Signal.map((function (param) {
    return false;
  }), source), Caml_option.some(Signal.map((function (m) {
    return !ready(m);
  }), source)), Caml_option.some(Signal.map((function (m) {
    if (allowed(m)) {
      return "";
    } else {
      return status(m);
    }
  }), source)), (function (param, param$1) {
    return Lui_elements.if_(partial_arg, (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___002_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map(status, source)));
        const partial_arg$1 = "muted";
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }), param, param$1);
  }), (function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, param, param$1);
  }), Caml_option.some(Signal.map(attachments_visible, source)), {
    hd: attach_button(source, on_attach),
    tl: /* [] */ 0
  }, {
    hd: retry_button(send, source),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$10, partial_arg$9, param, param$1);
      }),
      tl: /* [] */ 0
    }
  }, undefined, undefined, undefined, undefined, undefined, (function (param) {
    return Lui_elements.on_input(send, (function (value) {
      return {
        TAG: /* Messages */ 43,
        _0: {
          TAG: /* Draft */ 0,
          _0: value
        }
      };
    }), param);
  }), (function (param) {
    Curry._1(send, {
      TAG: /* Messages */ 43,
      _0: /* Send */ 0
    });
  }), (function (param) {
    Curry._1(send, {
      TAG: /* Messages */ 43,
      _0: /* Stop */ 1
    });
  }), undefined);
}

function status_line(source) {
  const partial_arg = Signal.map((function (m) {
    return m.messages.message !== "";
  }), source);
  const partial_arg$1 = "Sending message...";
  const partial_arg$2 = "muted";
  const partial_arg$3 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$4 = Signal.map((function (m) {
    return Stdlib__Option.fold(false, (function (a) {
      return a.phase === /* Sending */ 0;
    }), m.messages.attempt);
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.if_(partial_arg, (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___003_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (m) {
          return m.messages.message;
        }), source)));
        const partial_arg$1 = "notice";
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$4, partial_arg$3, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$5 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$6 = 16;
  const partial_arg$7 = 12;
  const partial_arg$8 = 8;
  return function (param, param$1) {
    return Lui_elements.row(undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, param, param$1);
  };
}

const picker_slot = Signal.state_slot("mapre-chat-picker");

function view(source, send) {
  return function (param, param$1) {
    return Lui_elements.scoped((function (context) {
      const picker = Signal.state_at(context.ui_scheduler, context.ui_state_scope, picker_slot, 0);
      const partial_arg_0 = composer_capsule(send, source, (function (param) {
        Signal.update(picker, (function (n) {
          return n + 1 | 0;
        }));
      }));
      const partial_arg = {
        hd: partial_arg_0,
        tl: /* [] */ 0
      };
      const partial_arg$1 = Signal.map((function (m) {
        return Mapre_web__Web_attachments_model.keys(m.messages.attachments);
      }), source);
      const partial_arg$2 = Signal.map((function (m) {
        return !Mapre_web__Web_attachments_controller.allowed(/* Conversation */ 1, m);
      }), source);
      const partial_arg$3 = Caml_option.some(picker.state_signal);
      const partial_arg_0$1 = function (param, param$1) {
        return Mapre_web__Web_attachment_input.view(partial_arg$3, partial_arg$2, partial_arg$1, (function (files) {
          Curry._1(send, {
            TAG: /* Attachments */ 44,
            _0: /* Conversation */ 1,
            _1: {
              TAG: /* Selected */ 0,
              _0: files
            }
          });
        }), (function (message) {
          Curry._1(send, {
            TAG: /* Attachments */ 44,
            _0: /* Conversation */ 1,
            _1: {
              TAG: /* Error */ 5,
              _0: message
            }
          });
        }), partial_arg, param, param$1);
      };
      const partial_arg_1 = {
        hd: status_line(source),
        tl: /* [] */ 0
      };
      const partial_arg$4 = {
        hd: partial_arg_0$1,
        tl: partial_arg_1
      };
      const partial_arg$5 = "composer-wrap";
      const partial_arg$6 = 0;
      const partial_arg$7 = 8;
      const partial_arg$8 = 12;
      const partial_arg$9 = 4;
      return function (param, param$1) {
        return Lui_elements.column(undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, param, param$1);
      };
    }), param, param$1);
  };
}

export {
  view,
}
/* picker_slot Not a pure module */
